import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Disclaimer = (props) => {
  const { colourScheme, customPadding } = props;

  const componentClasses = classNames('disclaimer', {
    [`disclaimer--${colourScheme}-scheme`]: colourScheme,
    [`disclaimer--padding-${customPadding}`]: customPadding
  });

  return (
    <section className={componentClasses}>
      <div className="disclaimer--inner" dangerouslySetInnerHTML={{ __html: props[props.src] }} />
    </section>
  );
};

Disclaimer.propTypes = {
  src: PropTypes.string,
  colourScheme: PropTypes.oneOf(['dark-navy', 'light-grey', 'grey']),
  customPadding: PropTypes.oneOf(['no-top', 'no-bottom', 'no-top-bottom'])
};

export default Disclaimer;
